import React from 'react';
import Navbar from './Navbar';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen min-w-0 bg-[#fafafa] flex flex-col text-gray-600 overflow-x-hidden">
      <Navbar />
      <main className="flex-1 w-full min-w-0">
        <div className="max-w-7xl w-full mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-5">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
